import { render } from "./PokemonPicture.vue?vue&type=template&id=3c2e4f88&scoped=true"
import script from "./PokemonPicture.vue?vue&type=script&lang=js"
export * from "./PokemonPicture.vue?vue&type=script&lang=js"

import "./PokemonPicture.vue?vue&type=style&index=0&id=3c2e4f88&scoped=true&lang=css"

import exportComponent from "C:\\Wbb\\Portfolio\\Vue Pokemon\\pokemon\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c2e4f88"]])

export default __exports__